(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'TravelMediaVideo',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		var type,
			index;

		$('.btn.btn-default.btn-radio').on('click', function _choiceClicked() {
			type  = $(this).children().first().val();
			index = $(this).children().first().data('index');

			if (type === 'url') {
				$('.video-link[data-index="' + index + '"]').removeClass('hidden');
				$('.video-upload[data-index="' + index + '"]').addClass('hidden');
			} else {
				$('.video-link[data-index="' + index + '"]').addClass('hidden');
				$('.video-upload[data-index="' + index + '"]').removeClass('hidden');
			}

			if (index !== 1) {
				// show the additional video upload form fields
				$('#video_container_' + index).removeClass('hidden');
			}
		});

		$('.skip').on('click', function _skipClicked(e) {
			var num_videos    = $('#travelmediavideo-num_videos').val(),
				links_added   = false,
				uploads_added = false,
				$i;

			e.preventDefault();

			for ($i = 0; $i < num_videos; $i++) {
				if ($('#travelmediavideo-url-' + $i).val() !== '') {
					links_added = true;
				}

				if ($('#travelmediavideo-dropped_count-appended-' + ($i + 1)).val() > 0) {
					uploads_added = true;
				}
			}

			if (links_added === true || uploads_added === true) {
				Adzuki.CustomConfirm({
					title  : 'Decision Time',
					content: 'You currently have selected videos to submit. Are you sure you want to skip submitting them at this time?',
					confirm: function confirm() {
						document.location = Adzuki.base_uri + '/TravelMedia/uploadPhoto/';
					}
				});
			} else {
				document.location = Adzuki.base_uri + '/TravelMedia/uploadPhoto/';
			}
		});
	};
}(jQuery, window.Adzuki || {}));